<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Assign Sub Department
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card-body">
              <div class="row">
              <div class="col-md-4 col-sm-12 mb-1 ">
                <div class="custom-control custom-control-secondary custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck1" checked="">
                  <label class="custom-control-label" for="customCheck1">Finance</label>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 mb-1 ">
                <div class="custom-control custom-control-secondary custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck2" checked="">
                  <label class="custom-control-label" for="customCheck2">Compliace</label>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 mb-1 ">
                <div class="custom-control custom-control-secondary custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck3" checked="">
                  <label class="custom-control-label" for="customCheck3">Accounts</label>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 mb-1 ">
                <div class="custom-control custom-control-secondary custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck5" checked="">
                  <label class="custom-control-label" for="customCheck5">Sales</label>
                </div>
              </div>
              <div class="col-md-4 col-sm-12 mb-1 ">
                <div class="custom-control custom-control-secondary custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="customCheck4" checked="">
                  <label class="custom-control-label" for="customCheck4">IT</label>
                </div>
              </div>
            </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" @click="$emit('hide')" class="btn btn-primary mt-2 mr-1">Save changes</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      selectedMerchant: null,
      // showModal: false,
    };
  },
  methods: {
    customNameForMultiselect({ email, first_name }) {
      return `${email}/${first_name}`
    },
  },
  watch: {
    show() {
      this.list = this.data
    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>
